import { useQuery } from "@tanstack/react-query";

import { apiGet, type OperatorStatusResponse } from "@/lib/api";

export function useOperatorStatus() {
  return useQuery<OperatorStatusResponse>({
    queryKey: ["operator-status"],
    queryFn: () => apiGet<OperatorStatusResponse>("/api/v1/operator/status"),
    refetchInterval: 30_000,
    staleTime: 15_000,
  });
}
